import React from 'react';
import { FooterLink } from '../FooterLink';
import css from './Footer.module.scss';

export const Footer = () => {
  return (
    <footer id="footer" data-testid="footer" className={css.footer}>
      <div className={css.footer}>
        <div className={css.innerContainer}>
          <span className={css.copyright}>
            Copyright &#169; LMS
            {' '}
            {new Date().getFullYear()}
          </span>
          <ul className={css.footerLinks}>
            <FooterLink href="https://www.lms.com/terms/terms-of-use.html">
              Terms of Use
            </FooterLink>
            <FooterLink href="https://www.lms.com/privacy.html">
              Privacy Policy
            </FooterLink>
            <FooterLink href="https://corporate.lms.com/contact-us/">
              Help
            </FooterLink>
          </ul>
        </div>
      </div>
    </footer>
  );
};
